import React from 'react';
import {
  createStyles,
  TableCellProps,
  TableRow,
  Theme,
  withStyles,
} from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import FsBodyMediumBold from 'ui-elements/typography/FsBodyMediumBold';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';
import FsBodyExtraSmallBold from 'ui-elements/typography/FsBodyExtraSmallBold';

interface AdditionalCellProps {
  withDistance?: boolean;
  withIconOnly?: boolean;
}

export const Value = withStyles(({ palette, spacing }: Theme) =>
  createStyles({
    root: {
      background: palette.grey[100],
      padding: spacing(0.3, 1),
      borderRadius: 4,
    },
  })
)(FsBodyMediumBold);

export const Role = withStyles(({ breakpoints }) =>
  createStyles({
    root: {
      whiteSpace: 'nowrap',
      fontWeight: 600,
      fontSize: 12,
      display: 'block',
      [breakpoints.up('lg')]: {
        fontWeight: 400,
        fontSize: 14,
      },
    },
  })
)(FsBodySmall);

export const HeadCell = withStyles(({ palette, spacing }: Theme) =>
  createStyles({
    root: {
      padding: spacing(2, 1),
      borderBottom: `1px solid ${palette.grey[200]}`,
    },
  })
)(
  ({
    withDistance,
    withIconOnly,
    ...otherProps
  }: TableCellProps & AdditionalCellProps) => {
    return (
      <TableCell
        {...otherProps}
        style={{
          paddingLeft: withDistance ? 40 : undefined,
          width: withIconOnly ? 24 : undefined,
        }}
      />
    );
  }
);

export const HeadLabel = withStyles(({ palette }: Theme) =>
  createStyles({
    root: {
      color: palette.grey[300],
      textTransform: 'uppercase',
    },
  })
)((props) => <FsBodyExtraSmallBold component="span" {...props} />);

export const BodyLabel = withStyles(({ palette }: Theme) =>
  createStyles({
    root: {
      color: palette.grey[300],
      textTransform: 'uppercase',
    },
  })
)((props) => <FsBodyExtraSmallBold component="span" {...props} />);

export const Cell = withStyles(({ palette, spacing }: Theme) =>
  createStyles({
    root: {
      padding: spacing(2, 1),
      borderBottom: `1px solid ${palette.grey[200]}`,
    },
  })
)(
  ({
    withDistance,
    withIconOnly,
    ...otherProps
  }: TableCellProps & AdditionalCellProps) => {
    return (
      <TableCell
        component="td"
        scope="row"
        {...otherProps}
        style={{
          paddingLeft: withDistance ? 40 : undefined,
          width: withIconOnly ? 24 : undefined,
        }}
      />
    );
  }
);

export const Row = withStyles(() =>
  createStyles({
    root: {
      '&.isLast :is(td, th)': {
        borderBottom: 0,
      },
    },
  })
)(TableRow);
